<template>
  <div class="page-wrap">
    <div class="page-content">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class PrimaryPageContent extends Vue {

}
</script>
<style lang="scss" scoped>
.page-wrap {
  background: var(--v-lightGrey-base);
}
.page-content {
  max-width: 700px;
  margin: 0 auto;
}
</style>
